const nonLetterGroupTitle = "#";
const startsWithLetter = new RegExp("^\\p{L}", "u");
const groupTitle = (title) => startsWithLetter.test(title) ? title?.charAt(0).toUpperCase() : nonLetterGroupTitle;
const groupBrands = (items, maxGroupLength = 4, locale) => {
  if (!items) {
    return [];
  }
  let currentTitle;
  return items.sort((a, b) => {
    const aLetter = startsWithLetter.test(a.title);
    const bLetter = startsWithLetter.test(b.title);
    return aLetter && !bLetter ? 1 : !aLetter && bLetter ? -1 : a.title.localeCompare(b.title, locale, {
      sensitivity: "base",
      usage: "sort",
      numeric: true
    });
  }).reduce((result, item) => {
    const title = groupTitle(item.title);
    let currentGroup = result[result.length - 1];
    if (title !== currentTitle) {
      currentTitle = title;
      currentGroup = { title, items: [] };
      result.push(currentGroup);
    }
    if (currentGroup.items.length === maxGroupLength) {
      currentGroup = { title: "", items: [] };
      result.push(currentGroup);
    }
    currentGroup.items.push(item);
    return result;
  }, []);
};
export {
  groupBrands
};
//# sourceMappingURL=group-brands.js.map
